import { createContext, useContext } from "react";
import type { Session } from "next-auth";
import { useSession as useNextAuthSession } from "next-auth/client";
export const AppSessionContext = createContext<Session | null>(null);

/**
 * A wrapper around next-auth's useSession that falls back to SSR-provided session
 * from AppSessionContext when the client cannot fetch a cookie-based session.
 * Returns a tuple matching next-auth's [session] signature for minimal changes.
 */
export function useAppSession(): [Session | null] {
  const [nextAuthSession] = useNextAuthSession();
  const ssrSession = useContext(AppSessionContext);
  return [nextAuthSession ?? ssrSession];
}